<template lang="pug">
  .sub-header.p-30.py-3.mb-30.is-sticky.is-sticky-at-0
    .row.align-items-center
      .col-auto
        slot(name="bottom-bar-left")
      .col-auto.ml-auto
        slot(name="bottom-bar-right")
</template>

<script>
export default {
  name: 'AppSubHeader',
};
</script>
